import {
    FAVORITES_EVENTS_RECEIVED,
    FAVORITES_EVENTS_TYPE_CHANGED,
    FAVORITES_LEAGUES_CHANGED,
} from './types';
import FavoritesService from '../../services/FavoritesService';

export const getFavoriteEvents = () => async dispatch => {
    const data = await FavoritesService.getFavoriteEvents();
    if (data?.item) {
        dispatch(saveFavoriteEvents(data.item.events));
    }
};

export const saveFavoriteEvents = items => ({
    type: FAVORITES_EVENTS_RECEIVED,
    payload: items,
});

export const addEventToFavorites = id => async (dispatch, getState) => {
    const data = await FavoritesService.addEventToFavorites(id);

    if (data?.item?.events) {
        const state = getState();
        const newEvents = [...state.favorites.events, ...data.item.events];
        dispatch(saveFavoriteEvents(newEvents));
    }
};

export const removeEventToFavorites = id => async (dispatch, getState) => {
    const data = await FavoritesService.removeEventFromFavorites(id);

    if (data.status === 200) {
        const state = getState();
        const newEvents = state.favorites.events.filter(event => event.id !== id);
        dispatch(saveFavoriteEvents(newEvents));
    }
};

export const changeFavoritesEventType = eventType => ({
    type: FAVORITES_EVENTS_TYPE_CHANGED,
    payload: eventType,
});

export const getFavoriteLeagues = () => async dispatch => {
    const { info, item } = await FavoritesService.getFavoriteLeagues();

    if (!info.success) return;

    dispatch(setFavoriteLeagues(item.leagues));
};

export const setFavoriteLeagues = leagues => ({
    type: FAVORITES_LEAGUES_CHANGED,
    payload: leagues,
});

export const modifyFavoriteLeague = ({ payload, params, isAlreadyFavorite }) => async (
    dispatch,
    getState
) => {
    const { info } = await FavoritesService.modifyFavoriteLeague(payload, params);

    if (!info.success) return;

    const reduxStore = getState();
    let newFavoriteLeagues = reduxStore.favorites.leagues;

    if (isAlreadyFavorite) {
        newFavoriteLeagues = newFavoriteLeagues.filter(league => league !== params.leagueId);
    } else {
        newFavoriteLeagues = newFavoriteLeagues.concat(params.leagueId);
    }

    dispatch(setFavoriteLeagues(newFavoriteLeagues));
};
